import { Inject, Options, Vue } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-admin-app/appInsights";
import store from "@/trust-admin-app/store";
import { EventEmitter } from "events";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";

@Options({
  components: {
    ErrorIndicator,
  },
  mixins: [FormatDateTimeMixin]
})
export default class PracticeAccountingDetails extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private loadingContent = false;
  private errorLoadingContent = false;

  private accountingDetailsTableHeadings = [
    { text: 'Trust account INV ID', value: 'invID', sortable: false },
    { text: 'Investigation date', value: 'investigationDate', sortable: false },
    { text: 'Year', value: 'year', sortable: false },
    { text: 'Trust account', value: 'trustAccount', sortable: false, cellClass: 'currency' },
    { text: 'Controlled', value: 'controlled', sortable: false, cellClass: 'currency' },
    { text: 'Power', value: 'power', sortable: false, cellClass: 'currency' },
  ];

  private accountingDetailsTableHeadingsFullWidth = [
    { text: 'Trust account INV ID', value: 'invID', sortable: false },
    { text: 'Investigation date', value: 'investigationDate', sortable: false },
    { text: 'Trust account', value: 'trustAccount', sortable: false, cellClass: 'currency' },
    { text: 'Year', value: 'year', sortable: false },
    { text: 'AC', value: 'ac1', sortable: false },
    { text: 'Controlled', value: 'controlled', sortable: false, cellClass: 'currency' },
    { text: 'Year', value: 'year', sortable: false },
    { text: 'AC', value: 'ac2', sortable: false },
    { text: 'Power', value: 'power', sortable: false, cellClass: 'currency' },
    { text: 'Year', value: 'year', sortable: false },
    { text: 'AC', value: 'ac3', sortable: false },
  ];

  private tableHeadings: any[] = this.accountingDetailsTableHeadings;

  private accountingDetails: any[] = [];
  private fullWidth = false;

  mounted(): void {
    window.scrollTo(0, 0);
    this.eventCtrl.on('side-panel-hidden', this.setTableClass);
    this.loadTableData();
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('side-panel-hidden', this.setTableClass);
  }

  private setTableClass(showHideStatus: boolean): void {
    this.tableHeadings = showHideStatus ? this.accountingDetailsTableHeadingsFullWidth : this.accountingDetailsTableHeadings;
    this.fullWidth = showHideStatus;
  }

  private loadTableData() {
    this.loadingContent = true;
    this.apiService.InvestigationApi?.apiV2InvestigationGetInvestigationAccountingDetailsByPracticeIdPracticeIdGet(
      this.selectedPractice.id
    )
      .then(res => {
        this.accountingDetails = res.data.data;
        this.loadingContent = false;
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to load accounting data');
        this.ai.trackException('Error getting accounting data: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })

  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

  private formatNumberToCurrencyWithZero(amount: number): string {
    // format number 1234567.20 to 1,234,567.20
    if (amount != null) {
      return '$  ' + amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    } else {
      return '$ 0';
    }
  }

}

